import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import styled from '@emotion/styled';
export var NavigationListIcon = styled(function (_a) {
    var Icon = _a.Icon, props = __rest(_a, ["Icon"]);
    return React.createElement(Icon, __assign({}, props));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-shrink: 0;\n"], ["\n  flex-shrink: 0;\n"])));
var templateObject_1;
//# sourceMappingURL=NavigationListIcon.js.map